import { JSX, SVGProps } from 'react';

export const Storyblok = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    width={48}
    height={57}
    viewBox="0 0 48 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m45.337.51-.051.054c1.326 0 2.137 1.027 2.182 2.284l.002.112v42.75c0 1.321-.77 2.129-2.012 2.176l-.118.002H16.607L8.74 56.386v-8.55H2.404c-1.273 0-2.34-.77-2.401-2.011L0 45.709V2.906C0 1.635 1.032.57 2.345.512L2.458.51zM30.7 9.223H8.74v30.498h19.34c1.475 0 2.895-.273 4.206-.6 1.224-.253 2.304-.793 3.287-1.394l.21-.13a6.6 6.6 0 0 0 2.24-2.214l.107-.183h-.056c.546-.979.82-2.123.82-3.485 0-2.123-.492-3.813-1.476-5.12-1.037-1.251-2.403-2.123-4.15-2.613a6.82 6.82 0 0 0 3.276-2.94c.711-1.308 1.094-2.669 1.094-4.085a8.15 8.15 0 0 0-1.857-5.283 7.6 7.6 0 0 0-2.185-1.743c-.817-.457-1.68-.678-2.679-.705zm-3.14 17.045c.632 0 1.106.308 1.528.825.39.538.594 1.19.579 1.854 0 .772-.264 1.39-.684 1.803-.44.382-.971.631-1.55.665l-.135.004H16.615v-5.15zm-.893-10.303a2.13 2.13 0 0 1 1.368.515c.369.36.579.928.579 1.7 0 .827-.187 1.47-.608 1.8l-.076.054c-.39.286-.868.527-1.352.563l-.121.004h-9.844v-4.636z"
      fill="#000"
    />
  </svg>
);
